import { createContext } from 'react';

export default createContext<{
  dispatchEvent: any;
}>({
  dispatchEvent: () => {},
});
